/// <amd-module name="TFS/CreateProject/Components/CodeOfConductStatement" />
import * as React from "react";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import * as PlatformResources from "Tfs/Platform/Resources";
import { FormatComponent } from "VSS/Platform/Components/Format";
import { IVssPageContext } from "VSS/Platform/Context";

export interface ICodeOfConductStatementProps {
    pageContext: IVssPageContext;
}

export const CodeOfConductStatement = (props: ICodeOfConductStatementProps): JSX.Element => {
    return (
        <div className="code-of-conduct-statement">
            <FormatComponent format={CreateProjectResources.CreateProjectCodeOfConductStatement}>
                <span>{PlatformResources.BrandWithProductName}</span>
                <a target="_blank" rel="noopener noreferrer" href={CreateProjectResources.CreateProjectCodeOfConductLink}>
                    {CreateProjectResources.CreateProjectCodeOfConductText}
                </a>
            </FormatComponent>
        </div>
    );
};
